<!-- <app-pias-layout> -->
<div pias-layout-content>
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <br />
  <div class="content">
    <div class="rm-assessment-container container-fluid" [formGroup]="rmassessmentForm">

      <h6 class="page-header">RECRUITING MANAGER ASSESSMENT FORM FOR NEW REPRESENTATIVE</h6>

      <div class="row">
        <div class="col-12">
          <h5 class="field-title">Information on New Representative</h5>
        </div>
        <!-- Name -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Name of New Representative (as in NRIC/Passport)
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="name" placeholder="Enter Name" readonly />
          </mat-form-field>
        </div>

        <!-- Passport No -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">star</mat-icon> -->
            NRIC/Passport No
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="nric" placeholder="Enter NRIC/Passport No" readonly />
          </mat-form-field>
        </div>

        <!-- Agent Channel -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Agent Channel
          </label>

          <mat-form-field class="w-100">
            <mat-select formControlName="agentchannel" placeholder="Select Agent Channel">
              @for(agentchannel of this.agentchannelList; track agentchannel) {
              <mat-option value="{{agentchannel.value}}">{{agentchannel.name}}</mat-option>
              }
            </mat-select>
            @if(this.rmassessmentForm.controls["agentchannel"].invalid
            && (this.rmassessmentForm.controls["agentchannel"].touched ||
            this.rmassessmentForm.controls["agentchannel"].dirty)
            ) {
            <mat-error>
              @if(this.rmassessmentForm.controls["agentchannel"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- hierarchy -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Agent reporting hierarchy (T1, T2, T3)
          </label>

          <mat-form-field class="w-100">

            <mat-select formControlName="hierarchy" placeholder="Select Agent reporting hierarchy">
              @for(hierarchy of this.hierarchyList; track hierarchy) {
              <mat-option value="{{hierarchy.value}}">{{hierarchy.name}}</mat-option>
              }
            </mat-select>
            @if(this.rmassessmentForm.controls["hierarchy"].invalid
            && (this.rmassessmentForm.controls["hierarchy"].touched ||
            this.rmassessmentForm.controls["hierarchy"].dirty)
            ) {
            <mat-error>
              @if(this.rmassessmentForm.controls["hierarchy"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Designation -->
        <div class="col-md-6">
          <label class="field-label">Designation</label>

          <mat-form-field class="w-100">

            <mat-select formControlName="designation" placeholder="Select Designation">
              @for(designation of this.designationList; track designation) {
              <mat-option value="{{designation.value}}">{{designation.name}}</mat-option>
              }
            </mat-select>
            @if(this.rmassessmentForm.controls["designation"].invalid
            && (this.rmassessmentForm.controls["designation"].touched ||
            this.rmassessmentForm.controls["designation"].dirty)
            ) {
            <mat-error>
              @if(this.rmassessmentForm.controls["designation"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- representative banding -->
        <div class="col-md-6">
          <label class="field-label">Representative's Banding</label>
          <mat-form-field class="w-100">
            <input matInput formControlName="representativebanding" placeholder="Enter Representative Banding" />
            <mat-icon matSuffix>percent</mat-icon>
          </mat-form-field>
        </div>

        <!-- Branch Name -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Branch
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="branch" placeholder="Enter Branch Name" readonly />
          </mat-form-field>
        </div>

        <!-- Recruiting Manager -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Recruiting Manager
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="manager" placeholder="Enter Recruiting Manager" readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h5 class="field-title">Recruiting Manager’s Recommendations</h5>
        </div>
        <mat-label class="field-label"></mat-label>
        <mat-form-field class="text-field">

          <textarea matInput formControlName="remarks" placeholder="Enter text"></textarea>
        </mat-form-field>
      </div>
      @if( (this.status === 'Rectification')){
      <h5 class="field-title">Rectification Attachments</h5>
      <div formArrayName="rectificationAttachemnts">
        @for (item of rectificationAttachemnts.controls; track $index; let i = $index) {
        <div class="row align-items-center" [formGroupName]="i">
          <div class="col-md-6">
            <label class="field-label">Attachment Name</label>
            <mat-form-field class="w-100">
              <mat-select matInput formControlName="categoryName" placeholder="Select Attachment Name">
                @for(categoryname of this.documentCategorynames; track categoryname) {
                <mat-option value="{{categoryname.name}}">{{categoryname.name}}</mat-option>
                }

              </mat-select>
              @let categoryNameControl = item.get('categoryName');
              @if(categoryNameControl?.invalid && (categoryNameControl?.touched || categoryNameControl?.dirty)) {
              <mat-error>
                @if(categoryNameControl?.errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-md-6 d-flex flex-column align-items-end">
            @let documentFilename = item.get('documentFilename');
            @if(isReadOnly() == false){
            <!-- Upload Button -->
            <label class="upload-btn" *ngIf="!documentFilename?.value">
              Upload Document

              <input type="file" id="documentFilename" accept=".pdf,.jpg,.jpeg,.png" hidden
                (change)="onDocumentFileChange($event,i)" />
            </label>
            }
            <input type="text" formControlName="documentFilename" hidden>

            @if (documentFilename?.value) {
            <!-- Uploaded File Name -->
            <div class="file-container" *ngIf="documentFilename?.value">
              @if(isReadOnly() == false){
              <span class="file-name">{{
                documentFilename?.value
                }}</span>

              <button mat-icon-button color="warn" class="delete-btn"
                (click)="removeFile('documentFilename','document',i)">✖</button>
              }
            </div>
            }

            @if(isReadOnly() == true){
            @let category = item.get('categoryName')?.value;
            @if(documentFilename?.value == ''){
            <button mat-stroked-button [disabled]="true">
              N/A
            </button>
            }@else{
            <button mat-stroked-button (click)="previewDoc(category,i)">
              View
            </button>
            }
            }
            @if(documentFilename?.invalid && (documentFilename?.touched || documentFilename?.dirty)) {
            <mat-error>
              @if(documentFilename?.errors?.["required"]) {
              <span class="w-100 text-end">{{message}}</span>
              }
              @else if(documentFilename?.errors?.['invalidType']){
              <span class="w-100 text-start">Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(documentFilename?.errors?.['maxSize']){
              <span class="w-100 text-start">File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
        </div>
        <!-- Delete -->
        <div class="col-md-3 text-end">
          @if (rectificationAttachemnts.length > 1 && isReadOnly() == false) {
          <button mat-stroked-button color="warn" type="button" (click)="removeRow(i)"><mat-icon>delete</mat-icon>Delete
            Attachment</button>
          }
        </div>
        }
        @if(isReadOnly() === false){
        <!-- Add Button -->
        <div class="text-end mt-3">
          <button mat-stroked-button color="primary" type="button" (click)="addRow()">
            + Add Attachment
          </button>
        </div>
        }
      </div>

      <div class="row">
        <div class="col-12">
          <h5 class="field-title">Recruiting Manager’s Rectification Recommendations</h5>
        </div>
        <mat-label class="field-label"></mat-label>
        <mat-form-field class="text-field">

          <textarea matInput formControlName="rectificationremarks" placeholder="Enter text"></textarea>
        </mat-form-field>
      </div>
      }

      <!-- Other Attachments -->
      <div class="section-card other-attachments-card">
        <div class="section-header">
          <mat-icon>attach_file</mat-icon>
          <span>Other Attachments</span>
        </div>
        <div class="container-fluid">
          <div class="row g-3">
            @for(key of otherAttachmentKeys; track key){
            <div class="col-md-6">
              <div class="upload-container">
                <div class="upload-box">
                  <input type="file"  [disabled]="isReadOnly()" [id]="key + 'fileName'" accept=".pdf,.jpg,.jpeg,.png"
                    (change)="onOtherAttachmentFileChange($event, key)">
                  <input type="text" [formControlName]="key + 'fileName'" hidden>

                  <!-- Show filename OR placeholder -->
                  @if(!this.rmassessmentForm.get(key + 'fileName')?.value){
                  <span>
                    Choose file
                  </span>
                  }
                  @if(this.rmassessmentForm.get(key + 'fileName')?.value){
                  <div class="attachment-row">
                    <span class="file-name">
                      {{ this.rmassessmentForm.get(key + 'fileName')?.value }}
                    </span>
                    @if(isReadOnly() === false){
                    <button mat-icon-button color="primary" class="delete-btn" (click)="removeOtherAttachmentFile(key)">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn" (click)="previewAttachment(key, key + 'fileName')">
                    <mat-icon>visibility</mat-icon>
                    </button>
                  </div>
                  }
                </div>
                @if(isReadOnly() === false){
                @if(!$first){
                @if(!this.rmassessmentForm.get(key + 'fileName')?.value){  
                <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                  matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                  <mat-icon>close</mat-icon>
                </button>
                }
                }
                @if($last){
                <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                  matTooltip="Add another attachment" (click)="addOtherAttachment()">
                  <mat-icon>add</mat-icon>
                </button>
                }
                }
              </div>
              @if(this.rmassessmentForm.get(key + 'fileName')?.invalid
              && (this.rmassessmentForm.get(key + 'fileName')?.touched ||
              this.rmassessmentForm.get(key + 'fileName')?.dirty)
              ) {
              <mat-error>
                @if(this.rmassessmentForm.get(key + 'fileName')?.errors?.['invalidType']){
                <span>Only PDF, JPG, PNG files are allowed.</span>
                }
                @else if(this.rmassessmentForm.get(key + 'fileName')?.errors?.['maxSize']){
                <span>File size must be less than or equal to 5MB.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </div>
            }
          </div>
        </div>
      </div>

      <h5 class="field-title">Acknowledgement</h5>
      <div class="rm-container container-fluid">
        <!-- <div class="rm-container"> -->
        <ol class="ack-list">
          <li>
            I recommend that the above applicant be granted appointment and undertake to supervise
            his/her activities.
          </li>
          <li>
            I am aware that my recommendation of the above applicant is subject to the acceptance
            and approval of Professional Investment Advisory Services Pte Ltd (PIAS) and Monetary
            Authority of Singapore (MAS). The Company has the right to reject this application at
            its sole discretion without assigning any reasons directly to me.
          </li>
          <li>
            I am fully aware that before the issuance of the Rep Code from PIAS, the new
            representative is not allowed to commence any sales activities or conduct any sales
            process, even if MAS has issued the Representative Number.
          </li>
          <li>
            In the event that PIAS is made known of any breach, disciplinary actions shall be taken
            against me and the new representative will be subjected to termination.
          </li>
          <li>
            Should the applicant be terminated within the first year of their service/time with PIAS
            (regardless voluntarily or in involuntarily), I undertake to pay the MAS lodgement fees
            and other costs (being the recovery cost incurred by the Company during the on-boarding
            process) if the Company is unable to recover the amount from the above applicant.
          </li>
        </ol>
        <!-- </div> -->
        <div class="row align-items-start">
          <mat-checkbox formControlName="declarationaccepted">I agree to the above
            declaration.</mat-checkbox>
          @if(this.rmassessmentForm.controls["declarationaccepted"].invalid
          && (this.rmassessmentForm.controls["declarationaccepted"].touched ||
          this.rmassessmentForm.controls["declarationaccepted"].dirty)
          ) {
          <mat-error>
            @if(this.rmassessmentForm.controls["declarationaccepted"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
          <div class="col-md-6">
            <label class="field-label">
              <!-- <mat-icon class="label-icon">star</mat-icon> -->
              Name of Recruiting Manager
            </label>

            <mat-form-field class="w-100">
              <input matInput formControlName="rm" placeholder="Enter Recruiting Manager " readonly />
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <label class="field-label">
              <!-- <mat-icon class="label-icon">star</mat-icon> -->
              Date
            </label>

            <mat-form-field class="w-100">
              <input type="date" matInput formControlName="date" readonly />
            </mat-form-field>
          </div>
        </div>
        @if(this.errormessage != ''){
        <mat-error>

          <span>{{errormessage}}</span>
        </mat-error>
        }
      </div>

      @if(isReadOnly() == false){
      <div class="form-actions mt-4">
        @if(this.status != 'Rectification'){
        <button class="save-btn  me-2" (click)="returnByRole()">
          <mat-icon>arrow_backward</mat-icon>
          <span>Return to Candidate</span>
        </button>
        }
        <button type="button" class="btn btn-submit btn-lg me-2" (click)="saveAndContinue()">
          <span>Save</span>
        </button>
        <button type="button" class="btn btn-submit btn-lg me-2" (click)="openConfirmDialog()"
          [disabled]="rmassessmentForm.invalid">
          <span>Submit</span>
        </button>
      </div>
      }
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="pdfUrl"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" width="100%" height="100%"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }
</div>
<!-- </app-pias-layout> -->